module.exports = __webpack_public_path__ + "img/rights-and-interests.ca834d35.png";